// extracted by mini-css-extract-plugin
export default {"cardRow":"Options_cardRow__T2J8+","linkCard":"Options_linkCard__6yFP7","linkText":"Options_linkText__WKu5B"};